import React from 'react';

interface StepDotsProps {
  step: number;
  total: number;
}

const StepDots = ({ step, total }: StepDotsProps) => {
  return (
    <div className="t-flex t-items-center">
      {[...new Array(total)].map((_, idx) => {
        return (
          <div
            key={idx}
            className={`${
              idx + 1 === step
                ? 't-w-2 t-h-2 t-opacity-100'
                : 't-w-1.5 t-h-1.5 t-opacity-40'
            } t-bg-alpha-600 t-rounded-full t-mr-2`}
          />
        );
      })}
    </div>
  );
};

export default StepDots;
